import React from "react";
import FilterReports from "../../componets/SubscriberManagementReport/FilterReports";
import {Datagrid, DateField, FunctionField, ListBase, ListToolbar, Pagination, Resource, TextField} from 'react-admin';
import {Box, Button as MuiButton} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import ExportReportToolbar, { BuildExportUrl } from "../../componets/SubscriberManagementReport/ExportReportToolbar";
import FilterChips from "../../componets/Ats/SuperAdminInbox/FilterChips";
import moment from "moment";
import {NumericFormat} from "react-number-format";
import {buildDefaultDateFilters} from "../../utils/dateRangePresets";
import { getStatusStyle } from "../../utils/statusStyles";
import { getAtsStatusDisplayLabel } from "../../utils/atsApplicationStatus";
import { ATS_API_URL } from "../../config";
import { normalizeScreeningSearch } from "../../utils/screeningSearch";
import { hasScreeningScore } from "../../utils/screeningScore";
import ReportReprocessingIndicator from "../../componets/Ats/ReportReprocessingIndicator";

const AdminLeadManagement = () => {
    return <>
        <Resource name="adminLeadManagement" list={AdminleadmanagementList} />
    </>
}

const MyList = ({ children, filters, actions, ...props }) => {
    return (
        <ListBase
            {...props}
            perPage={100} // Number of items per page
        >
            <ListToolbar
                filters={filters}
                actions={actions}
            />

            <FilterChips excludeKeys={['app_invitation_type','rangeto','rangefrom']} />
            {children}
            <Pagination rowsPerPageOptions={[100, 200, 300, 400, 500]} />
            <br />
            <br />
            <br />
            <br />
        </ListBase>
    );
};

export const AdminleadmanagementList = () => {
    const defaultFilters = React.useMemo(buildDefaultDateFilters, []);

    const buildExportUrl: BuildExportUrl = ({ filterValues, sort, total }) => {
        if (!ATS_API_URL) {
            return '';
        }

        const query: Record<string, string> = {};

        Object.entries(filterValues || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                const stringValue = String(value);
                query[key] = key === 'q' ? normalizeScreeningSearch(stringValue) : stringValue;
            }
        });

        if (sort?.field) {
            query._sort = sort.field;
        }

        if (sort?.order) {
            query._order = sort.order;
        }

        delete query._start;
        delete query._end;
        delete query.page;

        const safeTotal = typeof total === 'number' && total > 0 ? total : 1;
        query._start = '0';
        query._end = String(safeTotal);

        const params = new URLSearchParams(query);
        const queryString = params.toString();
        return `${ATS_API_URL}/admin/exportleadmanagementreportdv${queryString ? `?${queryString}` : ''}`;
    };

    return (
        <>
            <br />
            <br />
            <MyList
                filters={<FilterReports />}
                actions={<ExportReportToolbar buildExportUrl={buildExportUrl} />}
                sort={{ field: "ApplicationNumber", order: "DESC" }}
                filterDefaultValues={defaultFilters}
                children={<DataGrid />}
            />
        </>
    )
}
const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
    }
    return text;
};

// <List filters={<FilterReports/>} actions={<ExportAdminLead/>} pagination={page} perPage={100}sx={{marginTop: '20px'}}>
const DataGrid = () => {
    return (<Datagrid bulkActionButtons={false} sx={{
        "& .RaDatagrid-rowEven": { backgroundColor: "#F9F9F9" },
        "& .RaDatagrid-expandIcon": { color: "#fff" },
        "& .RaDatagrid-expandIconCell": { backgroundColor: "primary.main" },
        "& .RaDatagrid-headerCell": {
            fontWeight: "bold",
            fontSize: 12,
        },
        "& .RaDatagrid-table": {
            fontSize: 12,
        },
        "& .MuiToggleButton-root.Mui-selected": {
            fontWeight: 700,
        },
        marginTop: '40px',

    }}>
        {/* <TextField source="id" /> */}
        <TextField source="ApplicationNumber" label={'APP ID'} />
        <FunctionField
            sortBy="AppDate"
            label="Date"
            render={(record) => {
                // Format the AppDate using moment.js
                const formattedDate = moment.utc(record.AppDate).format('MM/DD/YYYY');

                return (
                    <>

                        <p>{formattedDate}</p> {/* Display the formatted AppDate */}
                        {/* <p>{record.LandLordPhone}</p> */} {/* Other data rendering if needed */}
                    </>
                );
            }}
        />
        <TextField source="FirstName" />
        <TextField source="LastName" />
        <FunctionField
            label={"Status"}
            source="ApplicationStatus"
            render={(record) => {
                const statusLabel = getAtsStatusDisplayLabel(record.ApplicationStatus);
                return (
                    <MuiButton
                        sx={{ minWidth: "80%" }}
                        title={statusLabel}
                        variant="contained"
                        disableElevation={true}
                        style={getStatusStyle(record.ApplicationStatus)}
                    >
                        {truncateText(statusLabel, 12)}
                    </MuiButton>
                );
            }}
        />
        <TextField source="Mobile" />
        <TextField source="Address" />
        <TextField source="City" />
        <TextField source="State" />
        <TextField source="ZipCode" />
        <FunctionField label="Current LandLord" render={(record) => {
            return (<>
                <p>{record.LandLordName || 'NA'}</p>
                <p>{record.LandLordPhone}</p>
            </>)
        }
        } />
        <DateField source="MoveInDate" />
        <FunctionField
            source="Rent"
            label="Rent"
            sortBy="Rent"
            render={(record) => {
                return !record.DesiredRent ? (
                    "NA"
                ) : (
                    <>
                        <NumericFormat
                            thousandSeparator=","
                            displayType="text"
                            thousandsGroupStyle="thousand"
                            decimalScale={2}
                            prefix="$"
                            fixedDecimalScale
                            value={record.DesiredRent}
                        />

                    </>
                );
            }}
        />
        <FunctionField
            source="MonthlyIncome"
            label="Monthly Income"
            sortBy="MonthlyIncome"
            render={(record) => {
                return !record.MonthlyIncome ? (
                    "NA"
                ) : (
                    <>
                        <NumericFormat
                            thousandSeparator=","
                            displayType="text"
                            thousandsGroupStyle="thousand"
                            decimalScale={2}
                            prefix="$"
                            fixedDecimalScale
                            value={record.MonthlyIncome}
                        />

                    </>
                );
            }}
        />
        <FunctionField
            source={"Score"}
            label="Score"
            render={(record) => {
                return (
                    <>
                        {hasScreeningScore(
                            record?.Score,
                            record?.ApplicationStatus, record?.HasPreservedScreeningReport
                        ) && (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                alignItems={"center"}
                            >
                                <Avatar
                                    sx={{
                                        bgcolor:


                                            record.ScreeningDetails ===
                                                "ConditionallyApproved" ||
                                                record.ScreeningDetails ===
                                                "Conditionally Approved"
                                                ? "#FFF8E2"
                                                : record.ScreeningDetails === "Unacceptable"
                                                    ? "#F8ECE2"
                                                    : record.ScreeningDetails ===
                                                        "NoAssessment" ||
                                                        record.ScreeningDetails === "No Assessment"
                                                        ? "#fff"
                                                        : record.ScreeningDetails === ""
                                                            ? "inherit"
                                                            : "#E6FDF0",
                                        color:
                                            record.ScreeningDetails ===
                                                "ConditionallyApproved" ||
                                                record.ScreeningDetails ===
                                                "Conditionally Approved"
                                                ? "#F9BB04"
                                                : record.ScreeningDetails === "Unacceptable"
                                                    ? "#FF4848"
                                                    : record.ScreeningDetails == "NoAssessment" ||
                                                        record.ScreeningDetails === "No Assessment"
                                                        ? "#000000"
                                                        : record.ScreeningDetails === ""
                                                            ? "inherit"
                                                            : "#46A96F",
                                        border:
                                            record.ScreeningDetails ===
                                                "ConditionallyApproved" ||
                                                record.ScreeningDetails ===
                                                "Conditionally Approved"
                                                ? "1px solid #F9BB04"
                                                : record.ScreeningDetails === "Unacceptable"
                                                    ? "1px solid #FF4848"
                                                    : record.ScreeningDetails ===
                                                        "NoAssessment" ||
                                                        record.ScreeningDetails === "No Assessment"
                                                        ? "1px solid #000000"
                                                        : record.ScreeningDetails === ""
                                                            ? "inherit"
                                                            : "1px solid #46A96F",
                                    }}
                                >

                                    {record?.Score}
                                </Avatar>
                                <ReportReprocessingIndicator active={record?.HasPreservedScreeningReport} />
                            </Box>

                        )}
                    </>
                );
            }}
        />




        <TextField source="LeadSource" />


    </Datagrid>

    )
}
export default AdminLeadManagement;
